import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { useEffect, RefObject } from 'react';
function useOutsideClickHandler(ref, onOutsideClick) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== onOutsideClick || $[1] !== ref) {
    t0 = () => {
      const handleClickOutside = function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target as Node)) {
          onOutsideClick();
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t1 = [ref, onOutsideClick];
    $[0] = onOutsideClick;
    $[1] = ref;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}
export default useOutsideClickHandler;